var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { ApiService } from '../../../../service/api.service';
import { ContentBaseService } from '../../../../component/base/contentbase.service';
import { ColumnService } from '../../../../items/columns/column/column.service';
var KtsOutlineService = /** @class */ (function (_super) {
    __extends(KtsOutlineService, _super);
    function KtsOutlineService(logger, api, colservice) {
        var _this = _super.call(this, logger, api) || this;
        _this.logger = logger;
        _this.api = api;
        _this.colservice = colservice;
        _this.fieldComps = [];
        return _this;
    }
    KtsOutlineService.prototype.sortItems = function (items) {
        items.sort(function (a, b) {
            if (a.disp_order < b.disp_order) {
                return -1;
            }
            if (a.disp_order > b.disp_order) {
                return 1;
            }
            return 0;
        });
    };
    KtsOutlineService.prototype.checkItem = function (rec) {
        var items = rec['items'] || [];
        var check = true;
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var item = items_1[_i];
            if (item.$type === "delete" /* Delete */) {
                continue;
            }
            if (!this.colservice.checkVal(item.name)) {
                check = false;
            }
            else if (item.task_outline_field_m.length === 0) {
                check = false;
            }
            else if (item.task_outline_field_m.length > 0) {
                for (var _a = 0, _b = item.task_outline_field_m; _a < _b.length; _a++) {
                    var field = _b[_a];
                    if (!this.colservice.checkVal(field.name)) {
                        check = false;
                        break;
                    }
                }
            }
            if (!check) {
                break;
            }
        }
        if (!check) {
            this.colservice.addError(this.fieldComps);
        }
        return check;
    };
    KtsOutlineService.prototype.resetFieldComp = function () {
        this.fieldComps = [];
    };
    KtsOutlineService.prototype.setFieldComp = function (compName) {
        this.fieldComps.push(compName);
    };
    KtsOutlineService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    KtsOutlineService.ctorParameters = function () { return [
        { type: NGXLogger },
        { type: ApiService },
        { type: ColumnService }
    ]; };
    return KtsOutlineService;
}(ContentBaseService));
export { KtsOutlineService };
var TaskOutline = /** @class */ (function () {
    function TaskOutline() {
        this.$type = "post" /* Post */;
        this.task_outline_field_m = [];
    }
    return TaskOutline;
}());
export { TaskOutline };
var TaskOutlineField = /** @class */ (function () {
    function TaskOutlineField() {
    }
    return TaskOutlineField;
}());
export { TaskOutlineField };
var ConstructionTaskOutlineField = /** @class */ (function () {
    function ConstructionTaskOutlineField() {
        this.$type = "post" /* Post */;
    }
    return ConstructionTaskOutlineField;
}());
export { ConstructionTaskOutlineField };
var TaskTemplate = /** @class */ (function () {
    function TaskTemplate(msg, readonly) {
        this.name = {};
        this.field = [];
        var width100per = { formClass: { width: '100per' } };
        this.name = {
            label: msg['au.COMPONENTS.label.task_outline_name'],
            key: 'name',
            controlType: 'text',
            readonly: readonly,
            required: true,
            params: width100per
        };
        this.field = [{
                label: msg['au.COMPONENTS.label.task_outline_field'],
                key: 'task_outline_field_m',
                readonly: readonly,
                required: true,
                items: [{
                        key: 'id',
                        hidden: true
                    }, {
                        key: 'name',
                        controlType: 'text',
                        required: true,
                        params: width100per
                    }]
            }];
    }
    return TaskTemplate;
}());
export { TaskTemplate };
//# sourceMappingURL=outline.service.js.map